export * from './social-links';

export const DEFAULT_CMS_TYPE = 'site';
